(function ($, doc) {

	/* POLYFILLS
	   ===================================================================== */

	var objectKeys = Object.keys || function (obj) {
		var keys = [];

		for (var key in obj) {
			if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) {
				keys.push(key);
			}
		}

		return keys;
	};

	var objectValues = Object.values || function (obj) {
		var values = [];

		for (var key in obj) {
			if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) {
				values.push(obj[key]);
			}
		}

		return values;
	};

	var isInteger = Number.isInteger || function (val) {
		return typeof val === 'number' && isFinite(val) && Math.floor(val) === val;
	};

	/* Aliases / Shortcuts
	   ===================================================================== */

	// Minifiable alias to common methods...
	function querySelector(selector) {
		return doc.querySelector(selector);
	}

	function querySelectorAll(selector) {
		return doc.querySelectorAll(selector);
	}

	function text(string) {
		return doc.createTextNode(string);
	}

	function element(tag, className, string) {
		var node = doc.createElement(tag);

		if (typeof className === 'string') {
			node.className = className;
		} else if (Array.isArray(className)) {
			node.className = className.join(' ');
		}

		if (typeof string === 'string') {
			node.appendChild(text(string));
		}

		return node;
	}

	function stripHtml(str) {
		str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
		str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');

		return str;
	}

	var data;

	var testEl = document.createElement('div');

	if ('dataset' in testEl) {
		data = function (element, key, value) {
			if (arguments.length === 3) {
				element.dataset[key] = value;
			} else {
				return element.dataset[key];
			}
		}
	} else {
		data = function (element, key, value) {
			if (arguments.length === 3) {
				element.setAttribute('data-' + key, value.toString());
			} else {
				return element.getAttribute('data-' + key);
			}
		}
	}

	/* Implementation
	   ===================================================================== */

	var tpl = {};

	tpl.thumbnail = function(image) {
		var img = element('img'),
			wrap = element('span', ['media-object', 'media-left', 'media-middle']);

		img.width  = 52;
		img.height = 52;
		img.src    = image.thumb_src;
		img.alt    = image.alt || image.title;

		wrap.appendChild(img);

		return wrap;
	};

	tpl.price = function (item) {
		var classes = ['variations-selector-price'];

		if (item.display_price !== item.display_regular_price) {
			classes.push('variations-selector-price--sale');
		}

		var price = isInteger(item.display_price) ? item.display_price : item.display_price.toFixed(2);

		return element('span', classes, '$' + price);
	};

	tpl.body = function (item, attr) {
		var wrap = element('span', ['media-body', 'media-middle']);

		wrap.appendChild(element('span', 'variations-selector-name', attr || objectValues(item.attributes).join(', ')), wrap.children[0]);
		wrap.appendChild(tpl.price(item));

		if (item.variation_description) {
			wrap.appendChild(element('span', 'variations-selector-desc', stripHtml(item.variation_description)));
		}

		return wrap;
	};

	tpl.radio = function () {
		var wrap = element('span', ['media-object', 'media-right', 'media-middle']);

		wrap.appendChild(element('span', 'variations-selector-radio'));

		return wrap;
	};

	tpl.render = function (def) {
		var fragment = doc.createDocumentFragment();
		var ul = element('ul', 'variations-selector-list');

		def.forEach(function (item) {
			var li = element('li', ['variations-selector-item', 'media']);

			data(li, 'id', item.variation_id);
			data(li, 'attributes', JSON.stringify(item.attributes));

			li.appendChild(tpl.thumbnail(item.image));
			li.appendChild(tpl.body(item));
			li.appendChild(tpl.radio(item));

			ul.appendChild(li);
		});

		fragment.appendChild(ul);

		return fragment;
	};

	tpl.renderMultiIndicator = function (item, attr) {
		var fragment = doc.createDocumentFragment();
		var wrapper  = element('div', 'variation-indicator');
		var itemWrap = element('div', ['variations-selector-item', 'media']);

		fragment.appendChild(wrapper);
		wrapper.appendChild(itemWrap);

		if (!item) {
			itemWrap.appendChild(element('div', 'variation-indicator-none', 'None Selected'));
		} else {
			itemWrap.appendChild(tpl.thumbnail(item.image));
			itemWrap.appendChild(tpl.body(item, Array.isArray(attr) ? attr.join(', ') : null));
		}

		return fragment;
	};

	// Filter function to keep non-blank strings.
	function nonBlankStrings(str) {
		return str !== '';
	}

	$(function () {
		// OnDOMReady
		var form = querySelector('.variations_form.cart');
		var def  = JSON.parse(data(form, 'product_variations'));

		// Order by price ascending.
		// def.sort(function (a, b) {
		// 	return a.display_price - b.display_price;
		// });

		var placeholder = querySelector('.variations-selector-placeholder');
		placeholder.parentElement.removeChild(placeholder);

		// Only activate on products with 1 attribute.
		if (def.length > 0 && objectKeys(def[0].attributes).length > 1) {
			var $table = $('table.variations').css('display', 'table');
			var variation = document.querySelector('input.variation_id');

			// Needed for the onChange event.
			$table.after(tpl.renderMultiIndicator());

			$table.on('change', 'select', function () {
				var attr = {};
				var id   = parseInt(variation.value, 10);

				$table.find('select').each(function () {
					attr[this.name] = this.value;
				});

				var items = [];
				var attrPres = objectValues(attr).filter(nonBlankStrings);

				if (attrPres.length) {
					items = def.filter(function (prospect) {
						if (prospect.id === id) {
							return true;
						}

						var match = true;

						objectKeys(attr).forEach(function (key) {
							// Blank is wildcard, so match against '' or ===
							match = match && (prospect.attributes[key] === '' || attr[key] === prospect.attributes[key]);
						});

						return match;
					})
				}

				$('.variation-indicator')
					.replaceWith(tpl.renderMultiIndicator(items.length ? items[0] : null, attrPres));
			});

			// Trigger the first update...
			$table.find('select:first').trigger('change');

			return;
		}

		var wrap = querySelector('.variations-selector');

		wrap.appendChild(tpl.render(def));

		var $wrap = $(wrap),
			$list = $wrap.find('.variations-selector-item');

		$wrap.on('click', '.variations-selector-item', function () {
			$list.filter('.active').removeClass('active');
			$(this).addClass('active');

			var attr = JSON.parse(data(this, 'attributes'));
			var wrap = $('.variations :input');

			objectKeys(attr).forEach(function (key) {
				wrap.filter('[name="' + key + '"]').val(attr[key]).trigger('change');
			});
		});

		$('input.variation_id').one('change', function () {
			if (this.value) {
				$list.filter('[data-id=' + this.value + ']').addClass('active');
			}
		});
	});

}(jQuery, document));